import axiosInstance from './axios';
import { API_URL } from '../config/api';

export const dashboardService = {
  getDashboardData: () => axiosInstance.get(`/api/dashboard`)
};
